import type { HeaderCartInfo } from './Header';
import { Button } from '../../../components/button';
import { Badge } from '../../../components/badge';
import { Image } from '../../../components/image';

export const ShoppingCartMenu = ({
    cartInfo,
    onUserCartClick,
}: {
    cartInfo: HeaderCartInfo;
    onUserCartClick: () => void;
}) => {
    // Need to apply !important to some classes to override legacy styles in themes/archipro2.
    return (
        <div>
            <h2 className="pt-2 pb-4 font-sans! text-4! leading-tight! font-bold! uppercase">
                Shopping Cart
            </h2>
            <div className="scrollbar-hide max-h-[50vh] overflow-y-auto border-t border-gray-200 py-4">
                {cartInfo.items.map((item) => (
                    <div
                        key={item.id}
                        className="flex h-20 cursor-default items-center gap-x-4 p-2 hover:bg-gray-100"
                    >
                        <div className="size-16 overflow-hidden rounded-md">
                            <Image
                                src={item.thumbnail.desktop}
                                alt={item.title}
                                fit="contain"
                            />
                        </div>
                        <div className="flex h-full flex-1 flex-col justify-between">
                            <h3 className="line-clamp-2 font-sans! text-4! leading-tight! font-medium!">
                                {item.title}
                            </h3>
                            <div className="items-between flex w-full items-center">
                                <span className="flex-1 text-3.5 leading-tight text-gray-500">
                                    {item.price}
                                </span>
                                {item.isSample && (
                                    <div className="relative -top-1 w-8">
                                        <Badge
                                            size="centeredCompact"
                                            text="small"
                                            color="secondary"
                                        >
                                            <span className="text-2.5! leading-tight! text-gray-600">
                                                SAMPLE
                                            </span>
                                        </Badge>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="min-w-10 text-right font-medium">
                            x{item.quantity}
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-between py-2 text-3.5 leading-tight font-medium">
                <span>Subtotal</span>
                <span>{cartInfo.itemTotal.ShortFormat}</span>
            </div>
            <div className="flex justify-between py-2 font-medium">
                <Button
                    size="default"
                    layoutMode="fillFlex"
                    onClick={onUserCartClick}
                >
                    Go To Cart
                </Button>
            </div>
        </div>
    );
};
